export const isNPackageProjection = ({ special_request } = {}) => {
  return special_request === '패키지 구매';
};
